"use client"

import { FunnelX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FunnelXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FunnelXIcon = component(Icon)({ as: FunnelX })
